import React from "react";
import "./contacto.scss";
import contacto from "../../assets/img/bg-dejanos-tu-consulta.png";
import { fetch } from "../../utils/fetch";
import { useToggle } from "../../hooks/useToggle";
import { validateModel } from "./validationSchema";
import { Formik } from "formik";
import Swal from "sweetalert2";
import ReCAPTCHA from "react-google-recaptcha";
import { PoliticaProteccionComponent } from "../../components/footer/politica-proteccion";
import { wrapEmailTemplate } from "../../utils/emailTemplate";
import emailsDevelop from "../../data/emails/emails.develop.json";
import emailsProd from "../../data/emails/emails.prod.json";
const emailsData =
  process.env.REACT_APP_ENVIROMENT_DEBUG === "true" ? emailsDevelop : emailsProd;

const DejanosTuConsultaPage = () => {
  const captcha = React.useRef(null);
  const politicaContactoToggle = useToggle();

  const initialValues = {
    nombre: "",
    apellido: "",
    email: "",
    celular_prefix: "",
    celular: "",
    tienePlanDeSaludSi: false,
    tienePlanDeSaludNo: false,
    motivo: "",
    mensaje: "",
    aceptoPrivacidad: false,
    validateAceptoPrivacidad: "",
  };

  const onSubmit = async (values, resetForm) => {
    if (captcha.current?.getValue()) {
      const correo = {
        to: emailsData.consulta,
        subject: "Solicitud de contacto",
        text: wrapEmailTemplate(`<b>Nombre</b> ${values.nombre} <br/>
        <b>Apellido</b> ${values.apellido} <br/>
        <b>Email</b> ${values.email} <br/>
        <b>Celular</b> (${values.celular_prefix})${values.celular} <br/>
        <b>¿ Es socio del Plan de Salud ?</b> ${
          values.tienePlanDeSaludSi ? "Si" : "No"
        } <br/>
        <b>Motivo</b> ${values.motivo} <br/>
        <b>Mensaje</b> ${values.mensaje} <br/>
        `),
      };
      if (values.motivo == "Baja") {
        for (const email of emailsData.consultaBaja) {
          correo.to = email;
          await fetch(`email`, "post", correo);
        }
      } else {
        correo.to = emailsData.consulta;
        await fetch(`email`, "post", correo);
      }

      resetForm();
      captcha.current?.reset();
      Swal.fire("Info!", "Solicitud de contacto enviada con éxito", "info");
    } else {
      Swal.fire("Info!", "Debe indicar que no es un robot", "info");
    }
  };

  const handleChangePlandeSaludSi = (e, setFieldValue) => {
    const name = e.target.name;
    const value = e.target.value;
    // console.log(name, value)
    setFieldValue("tienePlanDeSalud", "si", false);
    setFieldValue("tienePlanDeSaludSi", Boolean(true), false);
    setFieldValue("tienePlanDeSaludNo", Boolean(false), false);
  };

  const handleChangePlandeSaludNo = (e, setFieldValue) => {
    const name = e.target.name;
    const value = e.target.value ? e.target.value : false;
    // console.log(name, value)
    setFieldValue("tienePlanDeSalud", "no", false);
    setFieldValue("tienePlanDeSaludSi", Boolean(false), false);
    setFieldValue("tienePlanDeSaludNo", Boolean(true), false);
  };

  const handleChangeCel = (e, setFieldValue) => {
    const { value } = e.target;
    const onlyNumbers = /^[0-9]+$/; // Expresión regular para validar números
    if (value === "" || onlyNumbers.test(value)) {
      setFieldValue(e.target.name, value);
    }
  };

  const handleChangeNombre = (e, setFieldValue) => {
    const { value } = e.target;
    const onlyLettersAndSpaces = /^[A-Za-z\s]+$/; // Expresión regular para validar letras y espacios
    if (value === "" || onlyLettersAndSpaces.test(value)) {
      setFieldValue(e.target.name, value);
    }
  };

  return (
    <section
      className="section_contacto"
      style={{ minHeight: "calc(100vh - 25px - 100px - 200px)" }}
    >
      <div className="container-fluid">
        <div className="row">
          <div className="col-lg-6 p-5">
            <Formik
              initialValues={initialValues}
              enableReinitialize
              validationSchema={validateModel}
              onSubmit={(values, { setSubmitting, resetForm }) => {
                onSubmit(values, resetForm);
              }}
            >
              {({
                values,
                errors,
                touched,
                handleChange,
                handleBlur,
                handleSubmit,
                setFieldValue,
                isSubmitting,
                /* and other goodies */
              }) => (
                <form className="section_contacto_form">
                  <h2 className="subtitle-global">
                    <b>Dejanos tu consulta</b>
                    <hr className="hr6" />
                  </h2>
                  <div className="mb-4 fila-contacto align-items-center">
                    <div className="red-asterisk">
                      <label className="">
                        Nombre <span>*</span>
                      </label>
                    </div>
                    <div className="">
                      <input
                        type="text"
                        name="nombre"
                        maxLength={25}
                        value={values.nombre}
                        // onChange={handleChange}
                        onChange={(e) => handleChangeNombre(e, setFieldValue)}
                        className="form-control b-radius-20 shadow-blue"
                      />
                      <div className="text-danger">{errors?.nombre}</div>
                    </div>
                  </div>

                  <div className="mb-4 align-items-center fila-contacto">
                    <div className="">
                      <label
                        className="red-asterisk"
                        style={{ width: "100px", minWidth: "100px" }}
                      >
                        Apellido <span>*</span>
                      </label>
                    </div>
                    <div className="">
                      <input
                        type="text"
                        maxLength={25}
                        name="apellido"
                        value={values.apellido}
                        // onChange={handleChange}
                        onChange={(e) => handleChangeNombre(e, setFieldValue)}
                        className="form-control b-radius-20 shadow-blue"
                      />
                      <div className="text-danger">{errors?.apellido}</div>
                    </div>
                  </div>

                  <div className="mb-4 fila-contacto align-items-center">
                    <div className="red-asterisk">
                      <label className="">
                        Email <span>*</span>
                      </label>
                    </div>
                    <div className="">
                      <input
                        type="text"
                        name="email"
                        onChange={handleChange}
                        value={values.email}
                        className="form-control b-radius-20 shadow-blue"
                      />
                      <div className="text-danger">{errors?.email}</div>
                    </div>
                  </div>

                  <div
                    className="mb-4 fila-contacto align-items-center"
                    id="contacto-desktop"
                  >
                    <div className="">
                      <label className="red-asterisk">
                        Celular <span>*</span>
                      </label>
                    </div>
                    <div
                      style={{
                        display: "grid",
                        gridTemplateColumns: "100px 1fr",
                        columnGap: "10px",
                      }}
                    >
                      <div className="">
                        <input
                          type="text"
                          name="celular_prefix"
                          maxLength={4}
                          // onChange={handleChange}
                          value={values.celular_prefix}
                          onChange={(e) => handleChangeCel(e, setFieldValue)}
                          className="form-control b-radius-20 shadow-blue"
                        />
                        <div className="text-danger">
                          {errors?.celular_prefix}
                        </div>
                      </div>
                      <div className="">
                        <input
                          type="text"
                          name="celular"
                          maxLength={8}
                          value={values.celular}
                          // onChange={handleChange}
                          onChange={(e) => handleChangeCel(e, setFieldValue)}
                          className="form-control b-radius-20 shadow-blue"
                        />
                        <div className="text-danger">{errors?.celular}</div>
                      </div>
                    </div>
                  </div>

                  <div
                    className="mb-4 row align-items-center"
                    id="contacto-mobile"
                  >
                    <div className="col-lg-2 col-12">
                      <label className="">Celular *</label>
                    </div>
                    <div
                      className="col-lg-10 col-12"
                      style={{ display: "flex", gap: "5px" }}
                    >
                      <div style={{ display: "flex", flexDirection: "column" }}>
                        <input
                          type="text"
                          style={{ width: "80px" }}
                          name="celular_prefix"
                          maxLength={4}
                          // onChange={handleChange}
                          value={values.celular_prefix}
                          onChange={(e) => handleChangeCel(e, setFieldValue)}
                          className="form-control b-radius-20 shadow-blue"
                        />
                        <div className="text-danger">
                          {errors?.celular_prefix}
                        </div>
                      </div>
                      <div style={{ display: "flex", flexDirection: "column" }}>
                        <input
                          type="text"
                          name="celular"
                          maxLength={8}
                          value={values.celular}
                          // onChange={handleChange}
                          onChange={(e) => handleChangeCel(e, setFieldValue)}
                          className="form-control b-radius-20 shadow-blue"
                        />
                        <div className="text-danger">{errors?.celular}</div>
                      </div>
                    </div>
                  </div>

                  <div className="mb-4 row align-items-center ">
                    {/* <div className="col-lg-8">
                      <label className="">
                        {" "}
                        ¿ Es socio del Plan de Salud ? *
                      </label>
                    </div> */}
                    <div className="col-lg-8">
                      <label className="red-asterisk">
                        ¿Es socio del Plan de Salud ? <span>*</span>
                      </label>
                    </div>
                    <div className="col-lg-4 d-flex">
                      <div className="form-check mx-2">
                        <input
                          type="checkbox"
                          className="form-check-input"
                          name="tienePlanDeSaludSi"
                          checked={values.tienePlanDeSaludSi}
                          onChange={(e) =>
                            handleChangePlandeSaludSi(e, setFieldValue)
                          }
                          value={values.tienePlanDeSaludSi}
                          id="flexCheckDefault"
                        />
                        <label
                          className="form-check-label"
                          htmlFor="flexCheckDefault"
                        >
                          Si
                        </label>
                      </div>
                      <div className="form-check">
                        <input
                          type="checkbox"
                          className="form-check-input"
                          name="tienePlanDeSaludNo"
                          checked={values.tienePlanDeSaludNo}
                          onChange={(e) =>
                            handleChangePlandeSaludNo(e, setFieldValue)
                          }
                          value={values.tienePlanDeSaludNo}
                          id="flexCheckDefault"
                        />
                        <label
                          className="form-check-label"
                          htmlFor="flexCheckDefault"
                        >
                          No
                        </label>
                      </div>
                    </div>
                    <div className="text-danger">
                      {errors?.tienePlanDeSalud}
                    </div>
                  </div>

                  <div className="mb-4 fila-contacto align-items-center">
                    <div className="">
                      <label className="red-asterisk">
                        Motivo <span>*</span>
                      </label>
                    </div>
                    <div className="">
                      <select
                        name="motivo"
                        onChange={handleChange}
                        className="form-control b-radius-20 shadow-blue"
                      >
                        <option>Seleccione una opción</option>
                        <option>Autorizaciones</option>
                        <option>Facturacion y Cobranzas</option>
                        <option>Accesos a PSHB Online</option>
                        <option>Credencial Digital</option>
                        <option>Farmacia</option>
                        <option>Sugerencias</option>
                        <option>Turnos en el HB</option>
                        <option>Baja</option>
                        <option>Otros</option>
                      </select>
                      <div className="text-danger">{errors?.motivo}</div>
                    </div>
                  </div>

                  <div className="mb-4 row align-items-center">
                    <div className="col-lg-12">
                      <label className="mb-2 red-asterisk">
                        Mensaje <span>*</span>
                      </label>
                      <textarea
                        name="mensaje"
                        value={values.mensaje}
                        maxLength={500}
                        onChange={handleChange}
                        className="form-control b-radius-20 shadow-blue"
                        rows="4"
                      ></textarea>
                      <div className="text-danger">{errors?.mensaje}</div>
                    </div>
                  </div>

                  <div className="mb-4 form-check">
                    <input
                      name="aceptoPrivacidad"
                      value={values.aceptoPrivacidad}
                      onChange={handleChange}
                      className="form-check-input"
                      type="checkbox"
                      defaultValue
                      id="defaultCheck1"
                    />
                    <label
                      class="form-check-label red-asterisk"
                      for="defaultCheck1"
                    >
                      Acepto la{" "}
                      <a
                        href="javascript:void(0)"
                        onClick={politicaContactoToggle.onToggle}
                      >
                        {" "}
                        política de privacidad
                      </a>{" "}
                      del Hospital Británico <span>*</span>
                    </label>
                    <PoliticaProteccionComponent
                      visible={politicaContactoToggle.toggle}
                      onToggle={politicaContactoToggle.onToggle}
                    />
                    <div className="text-danger">
                      {errors?.validateAceptoPrivacidad}
                    </div>

                    {/* <PoliticaProteccionComponent
                    visible={politicaContactoToggle.toggle}
                    onToggle={politicaContactoToggle.onToggle} /> */}
                  </div>
                  <div className="mb-4 captcha">
                    <div className="row">
                      <div className="col-lg-12">
                        <div id="botCaptcha">
                          <ReCAPTCHA
                            ref={captcha}
                            sitekey={process.env.REACT_APP_CAPTCHA}
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="mb-4">
                    <button
                      type="button"
                      onClick={() => handleSubmit()}
                      className="btn2-color3-r"
                    >
                      Enviar
                    </button>
                  </div>
                </form>
              )}
            </Formik>
          </div>
          <div className="col">
            <img src={contacto} className="img-contacto" alt="bg-contacto" />
          </div>
        </div>
      </div>
    </section>
  );
};
export default DejanosTuConsultaPage;
